/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * A rule that decide if a column can be split. <p>Java class for splitRule complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="splitRule"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="datatype" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="columnNamePattern" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="lookupModule" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="lookupTableId" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="lookupColumnId" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="joinRelationship" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class SplitRule extends MoserObject{

	datatype = null;

	columnNamePattern = null;

	lookupModule = null;

	lookupTableId = null;

	lookupColumnId = null;

	joinRelationship = null;



	/**
	 * Gets the value of the datatype property.
	 * @return {String} possible object is {@link String}
	 */
	getDatatype() {
		return this.datatype;
	}

	/**
	 * Sets the value of the datatype property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDatatype(value) {
		var oldValue = this.datatype;
		this.datatype = value;
		this._setAndNotify(140, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the columnNamePattern property.
	 * @return {String} possible object is {@link String}
	 */
	getColumnNamePattern() {
		return this.columnNamePattern;
	}

	/**
	 * Sets the value of the columnNamePattern property.
	 * @param {String} value allowed object is {@link String}
	 */
	setColumnNamePattern(value) {
		var oldValue = this.columnNamePattern;
		this.columnNamePattern = value;
		this._setAndNotify(276, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the lookupModule property.
	 * @return {String} possible object is {@link String}
	 */
	getLookupModule() {
		return this.lookupModule;
	}

	/**
	 * Sets the value of the lookupModule property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLookupModule(value) {
		var oldValue = this.lookupModule;
		this.lookupModule = value;
		this._setAndNotify(277, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the lookupTableId property.
	 * @return {String} possible object is {@link String}
	 */
	getLookupTableId() {
		return this.lookupTableId;
	}

	/**
	 * Sets the value of the lookupTableId property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLookupTableId(value) {
		var oldValue = this.lookupTableId;
		this.lookupTableId = value;
		this._setAndNotify(278, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the lookupColumnId property.
	 * @return {String} possible object is {@link String}
	 */
	getLookupColumnId() {
		return this.lookupColumnId;
	}

	/**
	 * Sets the value of the lookupColumnId property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLookupColumnId(value) {
		var oldValue = this.lookupColumnId;
		this.lookupColumnId = value;
		this._setAndNotify(279, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the joinRelationship property.
	 * @return {String} possible object is {@link String}
	 */
	getJoinRelationship() {
		return this.joinRelationship;
	}

	/**
	 * Sets the value of the joinRelationship property.
	 * @param {String} value allowed object is {@link String}
	 */
	setJoinRelationship(value) {
		var oldValue = this.joinRelationship;
		this.joinRelationship = value;
		this._setAndNotify(280, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>SplitRule</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> SplitRule</code> object from.
	 * @return {SplitRule} an object of type <code>SplitRule</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createSplitRule();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "SplitRule";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 140, "datatype", null));
		featureList.push(this.createFeature(false, false, false, 276, "columnNamePattern", null));
		featureList.push(this.createFeature(false, false, false, 277, "lookupModule", null));
		featureList.push(this.createFeature(false, false, false, 278, "lookupTableId", null));
		featureList.push(this.createFeature(false, false, false, 279, "lookupColumnId", null));
		featureList.push(this.createFeature(false, false, false, 280, "joinRelationship", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 140:
			this.setDatatype((value));
			break;
		case 276:
			this.setColumnNamePattern((value));
			break;
		case 277:
			this.setLookupModule((value));
			break;
		case 278:
			this.setLookupTableId((value));
			break;
		case 279:
			this.setLookupColumnId((value));
			break;
		case 280:
			this.setJoinRelationship((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 140:
			return this.getDatatype();
		case 276:
			return this.getColumnNamePattern();
		case 277:
			return this.getLookupModule();
		case 278:
			return this.getLookupTableId();
		case 279:
			return this.getLookupColumnId();
		case 280:
			return this.getJoinRelationship();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 140:
			return this.getDatatype();
		case 276:
			return this.getColumnNamePattern();
		case 277:
			return this.getLookupModule();
		case 278:
			return this.getLookupTableId();
		case 279:
			return this.getLookupColumnId();
		case 280:
			return this.getJoinRelationship();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/SplitRule.js